import React from "react";
import CheckBoxIcon from "@/assets/icons/checkbox.svg";
import { twMerge } from "tailwind-merge";

export interface Props {
  name: string;
  value: boolean;
  handleChange: () => void;
  defaultClassName?: string;
  checkedClassName?: string;
}

const Checkbox = ({
  name,
  value,
  handleChange,
  defaultClassName,
  checkedClassName,
}: Props) => {
  return (
    <div className="group relative">
      <input
        type="checkbox"
        id={name}
        name={name}
        className="appearance-none"
        checked={value}
        onChange={handleChange}
      />
      <CheckBoxIcon
        onClick={handleChange}
        className={twMerge(
          "absolute bottom-[5px] -right-[4px] w-5 rounded-sm cursor-pointer",
          value
            ? `fill-primary ${checkedClassName}`
            : `fill-none bg-primary night:bg-invert light:bg-endemicGray-100 ${defaultClassName}`,
        )}
      />
    </div>
  );
};

export default Checkbox;
